// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__5ftBc","target":"Anchor_target__hUgh6"};